import * as sentry from 'sentry';


type SentryContext = {
  extra?: Record<any, any>;
  tags?: Record<any, any>;
  level?: string;
  fingerprint?: Array<string>;
};

function configureSentryScope(context: SentryContext, fn: () => void) {
  sentry.withScope((scope) => {
    const {extra, tags, level, fingerprint} = context;

    if (level) {
      // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'SeverityLevel'.
      scope.setLevel(level);
    }

    if (extra) {
      Object.keys(extra).forEach((extraKey) => {
        scope.setExtra(extraKey, extra[extraKey]);
      });
    }

    if (tags) {
      Object.keys(tags).forEach((tagKey) => {
        scope.setTag(tagKey, tags[tagKey]);
      });
    }

    if (fingerprint) {
      scope.setFingerprint(fingerprint);
    }

    fn();
  });
}

export function captureSentryException(err: unknown, context: SentryContext) {
  configureSentryScope(context, () => {
    sentry.captureException(err);
  });
}

export function captureSentryMessage(message: string, context: SentryContext) {
  configureSentryScope(context, () => {
    sentry.captureMessage(message);
  });
}
